export default __webpack_public_path__ + "assets/svg-sprite.90baa78fbe7fc4d33116e959b717e2a9.svg";